<template>
  <div class="antialiased">

    <Sidebar/>


    <div class="page">

      <Header hint="Cari" :enabled="false"/>

      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">
                  Monitoring Outlet Condition <br>
                </h2>
              </div>

              <div class="col-auto">
                <div class="row">
                  <div class="col-auto px-0">

                  </div>

                  <div class="col-auto">
                    <button class="btn btn-outline-primary ml-3" @click="_createExcel"  :disabled="loading" 
                    v-html="loading ? spin() : ic('download')+' Export Excel'"> </button>
                    <button class="btn btn-white  ml-3" v-html="ic('filter')+' Filter'"  @click="triggerFilter" > </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>
          <div class="alert alert-info" v-if="!loading && data_laporan.data.length == 0">
            <i class="fe fe-info mr-2"></i> Pilih filter untuk memuat monitoring Outlet Condition
          </div>
          <Nodata v-if="!loading && data_laporan.data.length == 0"/>
          <div class="box" v-if="data_laporan.data.length>0 && !loading">
            <div class="card">
              <div class="table-responsive">
                <table class="table table-vcenter table-hover card-table table-striped table-control  table-no-break">
                  <thead class="text-muted">
                    <th>No</th>
                    <th>NAMA TOKO</th>
                    <th>NOTE</th>
                    <th>UNGGAHAN FOTO</th>
                    <th>SALESMAN</th>
                    <th>TANGGAL TRANSAKSI</th>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in data_laporan.data" :key="i" >
                      <td>{{i+1}}</td>
                      <td>{{row.nama_toko}}</td>
                      <td>{{row.catatan}}</td>
                      <td class="preview-img pos-relative" style="width: 80px">
                        <span
                          class="extra bg-warning text-white"
                          v-if="row.status == 0"
                          >Non Aktif</span
                        >
                        <img
                          :src="
                            row.gambar == null
                              ? asset('no-image.png')
                              : row.gambar
                          "
                        />
                      </td>
                      <td>{{row.nama_salesman}}</td>
                      <td>{{row.tanggal}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

    <FormFilter/>

  </div>
</template>

<script>

import helper from "@/assets/js/helper.js";
import {mapActions, mapState} from "vuex";
import FormFilter from "./modals/filter.vue";

export default {
  name: "MonitoringOutletCondition",
  components: { FormFilter },

  data() {
    return {
    };
  },

  mixins: [helper],

  computed: {
    ...mapState(['loading']),
    ...mapState('monitoring_outlet_condition', {
      data_filter  : state => state.data_filter,
      data_laporan : state => state.data_laporan,
    }), 
  },
  methods: {
      ...mapActions('monitoring_outlet_condition', ['triggerFilter','getLaporan']),
      _createExcel(){
        let data_excel = []
        for (let i = 0; i < this.data_laporan.data.length; i++) {
          let d = this.data_laporan.data[i];
          let res = {
            'nama toko' : d.nama_toko,
            'note' : d.catatan,
            'salesman' : d.nama_salesman,
            'unggahan gambar' : d.gambar,
            'tanggal terakhir' : d.tanggal, 
          }
          data_excel.push(res)
        }
        this.createExcel({data: data_excel, filename: 'monitoring-outlet-condition'})
      }
  },
  created(){
  },

  mounted(){
    this.auth = JSON.parse(localStorage.user)
    this.getLaporan()
  },

};
</script>
<style lang="scss" scoped src="./image.scss" />
